import styled from 'styled-components';
import { fontStyle } from '../../styles/mixins';
import { GRAY_DARKER, FONT_SIZE_6, FONT_WEIGHT_BOLD, GRAY_LIGHTER } from '../../styles/variables';

export const Input = styled.input`
  border: 1px solid ${GRAY_LIGHTER};
  border-radius: 3px;
  ${fontStyle(GRAY_DARKER, FONT_SIZE_6, FONT_WEIGHT_BOLD)};
  height: 45px;
  max-width: 100%;
  padding: 10px;
  width: 100%;
`;



// WEBPACK FOOTER //
// ./src/components/Input/style.js